import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Body, Button, Card, Heading, I, Stack } from '@leanin/ui';
import { FlowShell } from '@/components/onboarding/FlowShell';
import { trackOnboardingStepCompleted } from '@/lib/analytics/events';
import { flowStepParams } from '@/lib/analytics/onboarding-steps';
import { Picture } from '@/components/media/Picture';
import nlManageSettings from '@/assets/onboarding/nl-manage-settings.png?w=440;880;1320&format=avif;webp;png&as=picture';
import { NL_ROLE, NL_STEPS } from './-steps';

// Network Leader onboarding tour — step 5 of 6.
// Annotated tour of the Network admin panel itself — overview, visibility,
// members, circles, mass email. The "how to get there" path lives in
// /onboarding/nl/access-network (the prior step).

export const Route = createFileRoute('/onboarding/nl/manage-network')({
  component: NLOnboardingManageNetworkPage,
});

function NLOnboardingManageNetworkPage() {
  const navigate = useNavigate();
  return (
    <FlowShell
      role={NL_ROLE}
      stepIndex={4}
      steps={NL_STEPS}
      minutes={1}
      title="Manage your Network settings to keep your community informed and connected."
      primary={
        <Button
          variant="primary"
          iconRight={I.arrow}
          onClick={() => {
            trackOnboardingStepCompleted(
              flowStepParams('/onboarding/nl/manage-network'),
            );
            navigate({ to: '/onboarding/nl/complete' });
          }}
        >
          Next
        </Button>
      }
      secondary={
        <Button
          variant="ghost"
          onClick={() => navigate({ to: '/onboarding/nl/access-network' })}
        >
          Back
        </Button>
      }
    >
      <Stack gap="md">
        <Heading level={2}>Manage your Network settings</Heading>
        <Body size="md">
          This is where you can update your Network details, manage members
          and Circles, adjust visibility settings, and share communications
          with your community.
        </Body>
        <Card pad="flush" clip>
          <Picture
            image={nlManageSettings}
            alt="Network admin panel with five annotated sections: Network overview, Visibility and Access, Members, Circles, and Mass Email"
            sizes="(max-width: 720px) 100vw, 880px"
            style={{ width: '100%', height: 'auto', display: 'block' }}
          />
        </Card>
      </Stack>
    </FlowShell>
  );
}
